"use strict";
import ReactCursor from "./util/react/cursor";
import classNames from "classnames";
export default {
  cursor: ReactCursor,
  makeBem: function(bemRoot) {
    return function bem(stringOrObject) {
      if (arguments.length === 0) {
        return bemRoot;
      } else {
        return _.chain(arguments).map(function(stringOrObject2) {
          if (_.isObject(stringOrObject2)) {
            return classNames(
              _.reduce(stringOrObject2, function(newObject, shouldDisplay, bemString) {
                newObject[bem(bemString)] = shouldDisplay;
                return newObject;
              }, {})
            );
          } else if (_.isEmpty(stringOrObject2)) {
            return bemRoot;
          } else if (_.str.startsWith(stringOrObject2, "__")) {
            if (_.str.include(stringOrObject2, "--")) {
              var parts = stringOrObject2.split("--");
              return [
                bemRoot + parts[0],
                bemRoot + parts[0] + "--" + parts[1]
              ];
            } else {
              return bemRoot + stringOrObject2;
            }
          } else if (_.str.startsWith(stringOrObject2, "--")) {
            return [bemRoot, bemRoot + stringOrObject2];
          } else {
            return stringOrObject2;
          }
        }).flatten().uniq().value().join(" ");
      }
    };
  }
};
